import filePdf from '../assets/images/file-pdf-solid-240.png';

export const ImageConfig = {
    pdf: filePdf
}